export default ["#3f51b5", "#4caf50", "#ff5722", "#009688", "#9c27b0", "#ff9800"];